
import ChinaAddressV2Data from 'vux/src/datas/china_address_v2.json'

import API from '../api'

export default {
name: 'm-measure',
data () {
return {
ChinaAddressV2Data: ChinaAddressV2Data
}
},
mounted () {
window.onresize = () => {
return (() => {
this.$refs.measureBody.style.maxHeight = (window.innerHeight - 120) + 'px'
})()
}
// this.$refs.measureBody.style.maxHeight = (window.innerHeight - 120) + 'px'
if (this.insuredBirthday !== '') this.getMeasurePayment()
},
computed: {
insuredValue: {
get () {
return this.$store.state.order.insuredValue
}
},
insuredBirthday: {
get () {
return this.$store.state.insured.birthday
},
set (value) {
this.$store.commit('updateInsuredBirthday', value)
}
},
holderArea: {
get () {
return this.$store.state.holder.area
},
set (value) {
this.$store.commit('updateHolderArea', value)
// 更新保额
for (let i = this.$store.getters.insuranceAmountsByBirthday.length - 1; i >= 0; i--) {
if (this.$store.getters.insuranceAmountsByBirthday[i].value === this.$store.state.order.insuranceAmount &&
this.$store.getters.insuranceAmountsByBirthday[i].accessable === false) {
this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByBirthday[0].value)
break
}
}
}
},
sexs () {
return this.$store.getters.sexs
},
sex: {
get () {
return this.$store.state.insured.sex
},
set (value) {
this.$store.commit('updateInsuredSex', value)
}
},
insuranceAmountsByBirthday () {
return this.$store.getters.insuranceAmountsByBirthday
},
insuranceAmount: {
get () {
return this.$store.state.order.insuranceAmount
},
set (value) {
this.$store.commit('updateOrderInsuranceAmount', value)
}
},
paymentPeriodsByBirthday () {
return this.$store.getters.paymentPeriodsByBirthday
},
paymentPeriod: {
get () {
return this.$store.state.order.paymentPeriod
},
set (value) {
this.$store.commit('updateOrderPaymentPeriod', value)
}
},
insurancePeriods () {
return this.$store.getters.accessableInsurancePeriodsByBitthday
},
orderInsurancePeriod: {
get () {
return this.$store.state.order.insurancePeriod
},
set (value) {
this.$store.commit('updateOrderInsurancePeriod', value)
}
},
paymentMethods () {
return this.$store.getters.accessablePaymentMethods
},
orderPaymentMethod: {
get () {
return this.$store.state.order.paymentMethod
},
set (value) {
this.$store.commit('updateOrderPaymentMethod', value)
}
},
birthdayPlaceholder () {
return '被保险人年龄(18周岁-60周岁)'
},
limitDate () {
return this.$store.getters.limitDate
},
candidateInsureds () {
return this.$store.getters.candidateInsureds
}
},
methods: {
onForWho (value) {
this.$store.commit('updateInsuredBirthday', '')
this.$store.commit('updateForWhoValue', value)
},
onBirthday (value) {
this.$store.commit('updatePaymentPeriod', '10')
this.$store.commit('updateInsuredBirthday', value)
},
onSex (value) {
this.$store.commit('updateInsuredSex', value)
},
onAmount (value) {
this.$store.commit('updateAmount', value)
},
onPaymentPeriod (value) {
this.$store.commit('updatePaymentPeriod', value)
},
onJobChange (value) {
this.$store.commit('updateJob', value)
},
getMeasurePayment (value) {
// 更新年龄
this.$store.commit('updateInsuredBirthday', value)
// 更新保额
for (let i = this.$store.getters.insuranceAmountsByBirthday.length - 1; i >= 0; i--) {
if (this.$store.getters.insuranceAmountsByBirthday[i].value === this.$store.state.order.insuranceAmount &&
this.$store.getters.insuranceAmountsByBirthday[i].accessable === false) {
this.$store.commit('updateOrderInsuranceAmount', this.$store.getters.insuranceAmountsByBirthday[0].value)
break
}
}
// 更新保险期间
for (let i = 0; i <= this.$store.getters.accessableInsurancePeriodsByBitthday.length - 1; i++) {
if (this.$store.getters.accessableInsurancePeriodsByBitthday[i].value === this.$store.state.order.insurancePeriod &&
this.$store.getters.accessableInsurancePeriodsByBitthday[i].accessable === false) {
// 如果20年可用，就20年
if (this.$store.getters.accessableInsurancePeriodsByBitthday[0].accessable) {
this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByBitthday[0].value)
} else if (this.$store.getters.accessableInsurancePeriodsByBitthday[3].accessable) {
// 如果65可用，就65
this.$store.commit('updateOrderInsurancePeriod', this.$store.getters.accessableInsurancePeriodsByBitthday[3].value)
} else {
// 否则就70，因为70始终可用
this.$store.commit('updateOrderInsurancePeriod', '70')
}
}
}
// 更新交费期间
for (let i = this.$store.getters.paymentPeriodsByBirthday.length - 1; i >= 0; i--) {
if (this.$store.getters.paymentPeriodsByBirthday[i].value === this.$store.state.order.paymentPeriod &&
this.$store.getters.paymentPeriodsByBirthday[i].accessable === false) {
this.$store.commit('updateOrderPaymentPeriod', this.$store.getters.paymentPeriodsByBirthday[i - 1].value)
}
}
if (this.$store.getters.ageFromBirthday === null) {
return
}
const that = this
this.$store.commit('updateMeasureReady', true)
API.getMeasurePayment(that)
},
changeSex () {
if (this.$store.getters.ageFromBirthday === null) {
this.$vux.toast.show({
type: 'text',
text: '客官，不选择年龄无法测算保费',
position: 'top',
width: '20em'
})
this.$store.commit('updateMeasureReady', false)
return
}
const that = this
this.$store.commit('updateMeasureReady', true)
API.getMeasurePayment(that)
},
changeAmountsByBirthday () {
if (this.$store.getters.ageFromBirthday === null) {
this.$vux.toast.show({
type: 'text',
text: '客官，不选择年龄无法测算保费',
position: 'top',
width: '20em'
})
this.$store.commit('updateMeasureReady', false)
return
}
this.$store.commit('updateMeasureReady', true)
// 如果存在保障计划Code
if (this.$route.query.calculationCode && this.$route.query.calculationCode !== null) {
console.log(this.$route.query.calculationCode)
const that = this
API.getMeasurePayment(that)
}
},
changePaymentPeriod () {
if (this.$store.getters.ageFromBirthday === null) {
this.$vux.toast.show({
type: 'text',
text: '客官，不选择年龄无法测算保费',
position: 'top',
width: '20em'
})
this.$store.commit('updateMeasureReady', false)
return
}
const that = this
this.$store.commit('updateMeasureReady', true)
API.getMeasurePayment(that)
},
changeInsurancePeriod () {
if (this.$store.getters.ageFromBirthday === null) {
this.$vux.toast.show({
type: 'text',
text: '客官，不选择年龄无法测算保费',
position: 'top',
width: '20em'
})
this.$store.commit('updateMeasureReady', false)
return
}
const that = this
this.$store.commit('updateMeasureReady', true)
API.getMeasurePayment(that)
},
stopPropagation (e) {
console.log(e)
e.stopPropagation()
e.prevent
}
}
}



// WEBPACK FOOTER //
// ./src/components/Measure.vue